import React, { useEffect } from 'react';
import ReactDOM from "react-dom";
import "./modal.scss";

const Modal = ({
    isOpen,
    children,
    size = 'medium', // default modal size
    className = '',
    onClose,
}) => {
    useEffect(() => {
        document.body.classList?.[isOpen ? 'add' : 'remove']?.('no-scroll');

        return () => {
            document.body.classList?.remove?.('no-scroll');
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="modal-overlay">
            <div
                className={`modal-content ${size} ${className}`}
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking on modal
            >
                <a className="modal-close" onClick={onClose}><i class="fa-solid fa-circle-xmark"></i></a>
                {children}
            </div>
        </div>,
        document.getElementById('modal-root')
    );
};

export default Modal;